/* import __COLOCATED_TEMPLATE__ from './text-question.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class RequestPrescreenerQuestionTypesTextQuestion extends Component {
  @service intl;

  get subText() {
    if (this.args.question.subtext) {
      let { maxLength } = this.args.question;
      return this.intl.t(this.args.question.subtext, maxLength ? { maxLength } : {});
    }
    return null;
  }
}
